import Settings from 'configs/Settings';

import Request from '@hotmart/request';

Request.register(Settings.api.player, {
  get: {
    'media.supported_langs': '/media/supported-lang',
    'media.info': '/media/:mediaCode'
  },
  put: {
    'media.update.language': '/media/:mediaCode/language'
  }
});

Request.register(Settings.api.playerFile, {
  get: {
    'media.signature': '/signature/:mediaCode'
  }
});

Request.register(Settings.api.thumbnail, {
  get: {
    'media.fetch.thumbnail': '/thumbnail/:mediaCode'
  }
});

Request.register(Settings.api.player, {
  post: {
    'media.register.thumbnail': {
      path: '/thumbnail/:id',
      options: {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    }
  }
});

Request.register(Settings.api.player, {
  get: {
    'media.fetch.report': '/media/:mediaCode/reports/club'
  }
});

Request.register(Settings.api.content, {
  get: {
    'media.mediaUrl': '/v8/player/media/:mediaCode/embed-url'
  }
});
